export const ROLES: any = {
  ADMINISTRADOR: "1",
  STAFF: "2",
  EMPRESA_TRANSPORTE: "10",
  BODEGUERO: "20",
  BOLETERO: "30",
  ADM_REGIONAL: "40",
  ADM_REGIONAL_SIN_ANULAR: "50",
  //CONDUCTOR: 50,
  BODEGUERO_BOLETERO: "60",
  //EMPRESA_TERMINAL: 100,
};

export const ROLES_STRING: any = {
  [ROLES.ADMINISTRADOR]: "Administrador Tuvi",
  [ROLES.STAFF]: "Staff Tuvi",
  [ROLES.EMPRESA_TRANSPORTE]: "Empresa Transporte",
  [ROLES.BODEGUERO]: "Bodeguero/a",
  [ROLES.BOLETERO]: "Boletero/a",
  [ROLES.ADM_REGIONAL]: "Adm. Regional|Encargado oficina",
  [ROLES.ADM_REGIONAL_SIN_ANULAR]:
    "Adm. Regional|Encargado oficina (Sin anular)",
  //[ROLES.CONDUCTOR]: 'Chófer',
  [ROLES.BODEGUERO_BOLETERO]: "Bodega y boleteria",
  //[ROLES.EMPRESA_TERMINAL]: 'Terminal de buses',
};

export const TipoReservaText = {
  T: "TERMINAL",
  W: "TUVI WEB",
  A: "TUVI MOVIL",
};
export const TipoVenta = {
  0: "TERMINAL",
  1: "TUVI WEB",
  2: "TUVI MOVIL",
};
export const CategoriaProductoReserva: any = {
  1: "EFECTIVO",
  3: "TARJETA",
  101: "QR SIMPLE",
  201: "TIGO MONEY",
  6666: "TRANSFERENCIA",
};

export const TipoDocumentoFacturaOptions = [
  { value: 1, label: "CI – CEDULA DE IDENTIDAD" },
  { value: 2, label: "CEX – CEDULA DE IDENTIDAD DE EXTRANJERO" },
  { value: 3, label: "PAS – PASAPORTE" },
  { value: 4, label: "OD – OTRO DOCUMENTO DE IDENTIDAD" },
  { value: 5, label: "NIT – NUMERO DE IDENTIFICACION TRIBUTARIA" },
];

export const TipoDocumentoFacturaText = (tipo: any) => {
  const find = TipoDocumentoFacturaOptions.find(
    (t) => t.value === Number(tipo)
  );
  return find ? find.label : "No encontrado";
};

export const MotivoAnulacionOptions = [
  { value: 1, label: "FACTURA MAL EMITIDA" },
  { value: 3, label: "DATOS DE EMISION INCORRECTOS" },
];

export const GuiaModalidadTxt: { [d: string]: string } = {
  "1": "PAGADO",
  "2": "POR PAGAR",
  "3": "POR COBRAR",
};

export enum TipoGuia {
  PAGADO = 1,
  POR_PAGAR= 2,
  POR_COBRAR=3
}

export enum TipoPago {
  Efectivo = 0,
  Transferencia = 1,
  Tarjeta = 2,
  Entidad = 3,
  QRSimple = 4,
  TigoMoney = 5,
  PorCobrar= 10
}

export const MapPagoTxt:{[k:string]: string}= {
  [TipoPago.Efectivo] : "EFECTIVO",
  [TipoPago.Entidad] : "PUNTOS DE COBRANZA",
  [TipoPago.PorCobrar]: "POR COBRAR",
  [TipoPago.QRSimple]: "TRANSFERENCIA QR SIMPLE",
  [TipoPago.Tarjeta]: "TARJETA",
  [TipoPago.TigoMoney]: "TIGO MONEY",
  [TipoPago.Transferencia]: "TRANSFERENCIA BANCARIA",
}